export async function copyText(text) {
    try {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    }
    catch {
        // Clipboard API can be present but blocked outside a secure context.
    }
    if (typeof document.execCommand !== 'function')
        return false;
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.readOnly = true;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    textarea.style.pointerEvents = 'none';
    document.body.append(textarea);
    textarea.select();
    textarea.setSelectionRange(0, text.length);
    try {
        return document.execCommand('copy');
    }
    catch {
        return false;
    }
    finally {
        textarea.remove();
    }
}
